import useAppBarTitle from 'hooks/use-app-bar-title';
import React from 'react';
import useAdminsPermissionRoleGet from '../../hooks/use-admins-permission-role-get';
import AdminPermissionRole from '../../components/admin-permission-role/admin-permission-role';
import { Root } from '../../index.styled';
import PageHeader from 'components/layout/page-header/page-header';
import { Button } from '@material-ui/core';

const pageTitle = 'Admins - Permission Management';

const AdminPermissionManagement: React.FC = () => {
    useAppBarTitle(pageTitle);
    const { data, isLoading } = useAdminsPermissionRoleGet();
    return (
        <Root>
            <PageHeader
                leftElement={<Button disabled>Create New Role</Button>}
            />
            <AdminPermissionRole data={data} isLoading={isLoading} />
        </Root>
    );
};

export default AdminPermissionManagement;
